import React from 'react';
import SettingsNav from './SettingsNav';
import SettingsHeader from './SettingsHeader';

/**
 * Settings shell: a left sidebar of consolidated admin sub-pages plus a main
 * column. Designed to render inside `<Layout fullWidth>` so it can sit flush
 * and span the viewport. Wraps each existing sub-page's content in `children`.
 *
 * When `title` is provided it renders a {@link SettingsHeader}; otherwise the
 * sub-page keeps its own existing header (Phase 4 wraps content unchanged).
 *
 * @param {Object} props
 * @param {string} [props.active] - Key of the active sidebar item (e.g. 'team').
 * @param {React.ReactNode} [props.title] - Optional standardized page title.
 * @param {React.ReactNode} [props.subtitle] - Optional page subtitle.
 * @param {React.ReactNode} [props.actions] - Optional header action buttons.
 * @param {React.ReactNode} props.children - The sub-page content.
 * @returns {JSX.Element}
 */
export default function SettingsShell({ active, title, subtitle, actions, children }) {
  return (
    <div className="flex flex-col md:flex-row min-h-[calc(100vh_-_5rem)]">
      <SettingsNav active={active} />
      <main className="flex-1 min-w-0 px-5 md:px-8 py-7">
        {title && <SettingsHeader title={title} subtitle={subtitle} actions={actions} />}
        {children}
      </main>
    </div>
  );
}
